// extracted by mini-css-extract-plugin
module.exports = {"root":"studentReport_root__Q3RmU","header":"studentReport_header__Q2hmj","title":"studentReport_title__361x1","close":"studentReport_close__Dcrzw"};